import { _ } from "./polyglot/polyglot.js";
import dialog from "./widgets/dialog.js";
import regionWidget from "./widgets/regionWidget.js";

/**
 * `inputFieldDialog` renders a modal confirmation dialog with a text input field.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} inputFieldDialog
 */
function inputFieldDialog(spec, my) {
	spec ||= {};
	my ||= {};

	const that = dialog(spec, my);

	my.confirmLabel = spec.confirmLabel || _("Confirm");
	my.cancelLabel = spec.cancelLabel || _("Cancel");

	my.initialValue = spec.initialValue || "";
	my.inputLabel = spec.inputLabel || "";
	my.placeholder = spec.placeholder || "";
	my.inputCss = spec.inputCss || "";
	my.inputValidator = spec.inputValidator || function () {};

	my.errorMessage = null;

	let input;

	my.form = regionWidget({
		content: function (html) {
			html.div(
				{
					klass: `form-group${my.errorMessage ? " has-error" : ""}`,
				},
				html.label(
					{
						for: `dialog-input-${that.getId()}`,
						klass: "col-sm-2 control-label",
					},
					my.inputLabel,
				),
				html.div(
					{
						klass: "col-sm-10",
					},
					(html) => {
						input = html.input(
							{
								type: "text",
								placeholder: my.placeholder,
								klass: ["form-control", my.inputCss],
								id: `dialog-input-${that.getId()}`,
								value: my.initialValue,
								"data-test": "form-input",
							},
							my.initialValue,
						);
					},
					(html) => {
						if (!my.errorMessage) {
							return;
						}

						html.p(
							{
								klass: "help-block danger",
							},
							my.errorMessage,
						);
					},
				),
			);
		},
	});

	that.onConfirm = my.events.createEvent();
	that.onCancel = my.events.createEvent();

	my.renderBodyOn = function (html) {
		html.div(
			{ klass: "modal-body" },
			my.content,
			html
				.form(
					{
						klass: "form-horizontal input-field-dialog-input",
					},
					my.form,
				)
				.on("submit", () => {
					my.confirm();
				}),
		);
	};

	my.footerRenderOn = function (html) {
		html.div(
			{ klass: "modal-footer" },
			html
				.button(
					{ klass: "btn btn-primary", "data-test": "ok" },
					my.confirmLabel,
				)
				.click(() => {
					my.confirm();
				}),
			html
				.button({ klass: "btn btn-default" }, my.cancelLabel)
				.click(() => {
					my.cancel();
				}),
		);
	};

	my.confirm = function () {
		my.initialValue = input.asJQuery().val();

		try {
			my.inputValidator(my.initialValue);
		} catch (error) {
			my.errorMessage = error;
			my.form.update();
			return;
		}

		that.hide();
		that.onConfirm.trigger(my.initialValue);
	};

	my.cancel = function () {
		that.hide();
		that.onCancel.trigger();
	};

	return that;
}

export default inputFieldDialog;
